import axios from "axios";

axios.defaults.withCredentials = true;

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const fileUrl = (path) => (path ? `${API}/files/${path}` : null);
export const imgSrc = (url) => (!url ? "" : /^https?:\/\//.test(url) ? url : fileUrl(url));
export const LOGO_SRC = "/00shots-logo.png?v=3";
export const INSTAGRAM_URL = "https://www.instagram.com/00shot/";

const d = (r) => r.data;

export const api = {
  // logo loop studio (admin)
  currentLogo: () => axios.get(`${API}/logos/current`).then(d),
  uploadLogo: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return axios.post(`${API}/logos`, fd).then(d);
  },
  resetLogo: () => axios.post(`${API}/logos/reset`).then(d),
  stills: () => axios.get(`${API}/stills`).then(d),
  makeStill: (logo_id) => axios.post(`${API}/stills`, { logo_id }).then(d),
  videos: () => axios.get(`${API}/videos`).then(d),
  makeVideo: (still_id, duration) => axios.post(`${API}/videos`, { still_id, duration }).then(d),

  // public site
  concerts: () => axios.get(`${API}/concerts`).then(d),
  concert: (id) => axios.get(`${API}/concerts/${id}`).then(d),
  myTickets: () => axios.get(`${API}/tickets/mine`).then(d),
  booked: () => axios.get(`${API}/calendar/booked`).then(d),
  merch: () => axios.get(`${API}/merch`).then(d),
  gallery: () => axios.get(`${API}/gallery`).then(d),
  submitRequest: (kind, body) => axios.post(`${API}/requests/${kind}`, body).then(d),
  checkout: (items, email) =>
    axios.post(`${API}/payments/checkout`, { items, email, origin_url: window.location.origin }).then(d),
  paymentStatus: (sid) => axios.get(`${API}/payments/status/${sid}`).then(d),
  myOrders: () => axios.get(`${API}/orders/mine`).then(d),

  // auth
  me: () => axios.get(`${API}/auth/me`).then(d),
  refresh: () => axios.post(`${API}/auth/refresh`).then(d),
  requestCode: (email) => axios.post(`${API}/auth/request-code`, { email }).then(d),
  verifyCode: (email, code) => axios.post(`${API}/auth/verify-code`, { email, code }).then(d),
  logout: () => axios.post(`${API}/auth/logout`).then(d),

  // admin
  adminList: (name) => axios.get(`${API}/admin/${name}`).then(d),
  adminCreate: (name, body) => axios.post(`${API}/admin/${name}`, body).then(d),
  adminUpdate: (name, id, body) => axios.put(`${API}/admin/${name}/${id}`, body).then(d),
  adminDelete: (name, id) => axios.delete(`${API}/admin/${name}/${id}`).then(d),
  adminRequests: (kind) => axios.get(`${API}/admin/requests/${kind}`).then(d),
  adminSetStatus: (kind, id, status) => axios.patch(`${API}/admin/requests/${kind}/${id}`, { status }).then(d),
  adminOrders: () => axios.get(`${API}/admin/orders`).then(d),
  checkin: (code, concert_id) => axios.post(`${API}/admin/checkin`, { code, concert_id }).then(d),
  undoCheckin: (code) => axios.post(`${API}/admin/checkin/${encodeURIComponent(code)}/undo`).then(d),
  checkinStats: () => axios.get(`${API}/admin/checkin/stats`).then(d),
  adminUpload: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return axios.post(`${API}/admin/upload`, fd).then(d);
  },
};

export const errMsg = (e) => {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => x?.msg || "").filter(Boolean).join(" ");
  return e?.message || "Something went wrong";
};

export const money = (n) => `$${Number(n || 0).toFixed(2)}`;
export const shareUrl = (id) => `${API}/share/shows/${id}`;
export const qrUrl = (code) => `${API}/tickets/qr/${code}.png`;
